import * as React from "react"
import * as ReactDOM from "react-dom"

const styles = require("./modal.component.styl")

export interface Props {
    readonly className?: string
    readonly opened?: boolean
    readonly onOpen?: () => void
    readonly onHide?: () => void
}

export interface States {
    opened: boolean
}

export class Modal extends React.PureComponent<Props, States> {
    node: HTMLDivElement
    bodyDom: HTMLBodyElement

    static defaultProps = {
        opened: false
    }

    constructor(props: Props) {
        super(props)
        this.state = {
            opened: this.props.opened
        }
        this.bodyDom = document.getElementsByTagName("body")[0]
    }

    componentWillReceiveProps(nextProps: Props) {
        if (nextProps.opened === this.state.opened) {
            return false
        }
        if (nextProps.opened && !this.props.opened) {
            this.onShow()
        }

        if (this.props.opened && !nextProps.opened) {
            this.onHide()
        }
    }

    onShow = () => {
        this.node = document.createElement("div")
        this.node.className = "ReactModal"
        this.bodyDom.appendChild(this.node)
        this.bodyDom.classList.add("modal-open")
        this.bodyDom.addEventListener("touchmove", this.preventDefault, false)
        const { children } = this.props
        const onClose = (e: React.MouseEvent<HTMLElement>) => {
            if (
                e.target instanceof HTMLDivElement &&
                e.target.className.indexOf("react-modal-container") >= 0
            ) {
                this.onHide()
            }
        }
        const modal = (
            <div>
                <div className={ styles["react-modal-mask"] } />
                <div
                    className={ styles["react-modal-container"] }
                    onClick={ onClose }
                >
                    {children}
                </div>
            </div>
        )
        const allClass = document.getElementsByClassName("ReactModal")
        ReactDOM.render(modal, allClass[allClass.length - 1])

        this.setState(
            {
                opened: true
            },
            () => {
                if (this.props.onOpen) {
                    this.props.onOpen()
                }
            }
        )
    }

    onHide = () => {
        if (this.node) {
            this.bodyDom.classList.remove("modal-open")
            this.bodyDom.removeEventListener("touchmove", this.preventDefault)
            ReactDOM.unmountComponentAtNode(this.node)
            this.setState(
                {
                    opened: false
                },
                () => {
                    if (this.props.onHide) {
                        this.props.onHide()
                    }
                }
            )
        }
    }

    private preventDefault = (e: TouchEvent) => {
        e.preventDefault()
    }

    render() {
        return null
    }
}
